<div class="flex gap-xs flex-wrap flex-col md:flex-row">
  @for (answer of answers; track answer) {
    <core-chip [label]="answer" class="block md:inline-block" [size]="(isMobile$ | async) ? 'lg' : 'md'" (svsChanged)="changed(answer, $event.detail)"></core-chip>
  }
</div>
